/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelP44ConfigProfileLookup.ts        *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/p44-config-profile-lookup";

export class AutogenModelP44ConfigProfileLookup<RowType extends ModelRow> extends Endpoint<RowType, RowP44ConfigProfileLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowP44ConfigProfileLookup extends ModelRow<RowP44ConfigProfileLookupFields> {
	constructor(values?: Partial<RowP44ConfigProfileLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowP44ConfigProfileLookupFields {
	company_id: string;
	config_type: string;
	descr: string;
	disp_allow_unaccepted_acc: string;
	disp_enable_truncation: string;
	disp_is_pickup_only: string;
	disp_is_presched_pickup: string;
	disp_note_config: string;
	disp_unit_conversion: string;
	disp_use_def_login: string;
	id: string;
	img_use_def_login: string;
	quote_all_ex_length: string;
	quote_all_guaranteed: string;
	quote_all_inside_del: string;
	quote_all_service_levels: string;
	quote_allow_unaccepted_acc: string;
	quote_timeout: number;
	quote_unit_conversion: string;
	quote_use_def_login: string;
	send_disp_request: string;
	tracking_use_def_login: string;
}

